/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivityPageRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'
import {ActivityPageResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/service.pb'


export const activityPage = (request:ActivityPageRequest, options?: CashRequestOptions) => post<ActivityPageRequest, ActivityPageResponse>("/2.0/cash/activity-page", request, {...options, rejectOnError: true })